import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';

const trackTourEvent = (eventName: string, additionalData: Record<string, unknown> = {}) => {
    const debugConfig = createDebugConfig();

    trackCustomEvent(
        eventName,
        {
            flow_name: 'guided_tour',
            ...additionalData,
        },
        debugConfig
    );
};

export const trackTourStart = () => {
    trackTourEvent('tour_start', {
        trigger: 'click',
        element_name: 'start_button',
    });
};

export const trackTourDecline = (action: 'skip' | 'close') => {
    trackTourEvent('tour_decline', {
        trigger: 'click',
        element_name: `${action}_button`,
    });
};

export const trackTourStep = (stepIndex: number, navigationMethod: 'next' | 'prev' | 'dot') => {
    trackTourEvent('tour_step', {
        trigger: 'click',
        element_name: navigationMethod,
        element_state: stepIndex + 1,
    });
};

export const trackTourComplete = (timeSpentSeconds: number) => {
    trackTourEvent('tour_complete', {
        trigger: 'click',
        element_name: 'tour',
        element_state: `${timeSpentSeconds}s`,
    });
};

export const trackTourDrop = (lastStepIndex: number, timeSpentSeconds: number) => {
    trackTourEvent('tour_drop', {
        trigger: 'click',
        element_name: lastStepIndex + 1,
        element_state: `${timeSpentSeconds}s`,
    });
};
